export default __webpack_public_path__ + "static/media/TW_Arena_logo_white.2505b9f6.png";